import { atom } from "recoil";

const travelState =atom({
    key: 'travel',
    default: 'Cairo'
})

export default travelState